import React from 'react';
import { Mail } from 'lucide-react';

const DisclaimerPage = () => {
  return (
    <div className="min-h-screen bg-slate-50 py-12" data-testid="disclaimer-page">
      <div className="container mx-auto px-4 sm:px-6 md:px-12 max-w-4xl">
        <h1 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-8 font-heading text-center">
          Disclaimer
        </h1>
        
        <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-6 sm:p-10">
          <div className="prose prose-slate max-w-none text-center">
            <p className="text-slate-600 leading-relaxed mb-6">
              AuctionGuru is an independent property aggregation platform that collects and displays publicly available auction property listings from various third-party auction houses and property websites across the United Kingdom.
            </p>

            <p className="text-slate-600 leading-relaxed mb-6">
              We do not own, control, or manage any of the properties listed on this platform. All property information, including descriptions, images, guide prices, and auction details, is sourced from publicly accessible listings and remains the intellectual property of the respective auction houses or listing providers.
            </p>

            <p className="text-slate-600 leading-relaxed mb-6">
              AuctionGuru provides a simplified and centralized interface to help users discover auction properties more efficiently. Users are always directed to the original auctioneer's website for full details, legal documentation, and to participate in any auction process.
            </p>

            <p className="text-slate-600 leading-relaxed mb-6">
              While we strive to keep information accurate and up to date, we do not guarantee the completeness, accuracy, or reliability of any listing. Users should verify all details directly with the original auctioneer before making any decisions.
            </p>

            <p className="text-slate-600 leading-relaxed mb-6">
              If you are a property owner, auction house, or representative and would like your content removed or modified, please contact us at:
            </p>

            <div className="flex items-center justify-center gap-2 text-[#F5A623] font-medium mb-6">
              <Mail className="h-5 w-5" />
              <a href="mailto:Support@AuctionGuru.co.uk" className="hover:underline">
                Support@AuctionGuru.co.uk
              </a>
            </div>

            <p className="text-slate-600 leading-relaxed mb-6">
              We will respond promptly to all legitimate requests.
            </p>

            <p className="text-slate-600 leading-relaxed font-medium">
              AuctionGuru is not affiliated with any auction house unless explicitly stated.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DisclaimerPage;
